import { createContext, useContext } from "react";

import { SecurityFormModel } from "./SecurityFormModel.ts";

export const SecurityFormContext = createContext<SecurityFormModel>(
  {} as SecurityFormModel
);

export const useSecurityFormContext = () => useContext(SecurityFormContext);
